import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  OnInit,
  TrackByFunction
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FeeBasedService } from "@vp/models";
import { Observable } from "rxjs";
import { EditServiceCostModel } from "../edit-service-cost.service";

export interface OverrideServiceFormDialogData {
  feeBasedServices: Observable<FeeBasedService[]>;
  override: EditServiceCostModel;
  mode: "edit" | "create";
}

@Component({
  selector: "vp-add-service-form",
  standalone: false,
  templateUrl: "./add-service-form.component.html",
  styleUrls: ["./add-service-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AddServiceFormComponent implements OnInit {
  form!: UntypedFormGroup;
  originalClose;

  constructor(
    private readonly dialogRef: MatDialogRef<AddServiceFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: OverrideServiceFormDialogData,
    private readonly fb: UntypedFormBuilder
  ) {
    // Add confirm close logic to dialog to centralize
    this.originalClose = this.dialogRef.close;
    this.dialogRef.close = this.confirmClose.bind(this);
  }

  @HostListener("window:keyup.esc") onKeyUp() {
    this.confirmClose({ save: false });
  }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    event.returnValue = false;
  }

  ngOnInit(): void {
    this.form = this.getForm(this.data.override);
    if (this.data.mode === "edit") {
      this.form.get("friendlyId")?.disable();
    }
  }

  // Satisfies template-use-track-by-function
  trackByFn: TrackByFunction<FeeBasedService> = (_index: number, item: FeeBasedService) =>
    item.friendlyId;

  confirmClose(result: { save?: boolean }) {
    if (result.save && this.form.valid) {
      const formValue = this.form.getRawValue();
      this.originalClose.bind(this.dialogRef)(formValue);
    } else {
      if (this.form.pristine || this.form.invalid) {
        this.originalClose.bind(this.dialogRef)();
      } else {
        if (confirm("Are you sure you want to cancel and potentially lose data?")) {
          this.originalClose.bind(this.dialogRef)();
        }
      }
    }
  }

  private getForm(serviceOverride: EditServiceCostModel) {
    return this.fb.group({
      friendlyId: [serviceOverride.friendlyId],
      active: [serviceOverride.active],
      fee: [serviceOverride.fee]
    });
  }
}
